import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import config from '@/conf/config'
import {messages as adminI18n} from './adminI18n'
import {messages as affiliateI18n} from './affiliateI18n'
import {messages as commonI18n} from './commonI18n'
import {messages as devI18n} from './devI18n'
import {messages as frameI18n} from './frameI18n'
import {messages as goodsI18n} from './goodsI18n'
import {messages as groupI18n} from './groupI18n'
import {messages as housekeepingI18n} from './housekeepingI18n'
import {messages as orderI18n} from './orderI18n'
import {messages as partnerI18n} from './partnerI18n'
import {messages as phoneI18n} from './phoneI18n'
import {messages as plateformI18n} from './plateformI18n'
import {messages as propertyI18n} from './propertyI18n'
import {messages as shopI18n} from './shopI18n'
import {messages as userI18n} from './userI18n'
import {messages as couponI18n} from './couponI18n'
import {messages as commonLang} from './commonLang'

Vue.use(VueI18n)

// 合并所有语言配置
const messages = {
  en: {
    ...enLocale,
    ...adminI18n.en,
    ...affiliateI18n.en,
    ...commonI18n.en,
    ...devI18n.en,
    ...frameI18n.en,
    ...goodsI18n.en,
    ...groupI18n.en,
    ...housekeepingI18n.en,
    ...orderI18n.en,
    ...partnerI18n.en,
    ...phoneI18n.en,
    ...plateformI18n.en,
    ...propertyI18n.en,
    ...shopI18n.en,
    ...userI18n.en,
    ...couponI18n.en,
    ...commonLang.en,
  },
  zh: {
    ...zhLocale,
    ...adminI18n.zh,
    ...affiliateI18n.zh,
    ...commonI18n.zh,
    ...devI18n.zh,
    ...frameI18n.zh,
    ...goodsI18n.zh,
    ...groupI18n.zh,
    ...housekeepingI18n.zh,
    ...orderI18n.zh,
    ...partnerI18n.zh,
    ...phoneI18n.zh,
    ...plateformI18n.zh,
    ...propertyI18n.zh,
    ...shopI18n.zh,
    ...userI18n.zh,
    ...couponI18n.zh,
    ...commonLang.zh,
  }
}

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: config.lang,
  messages
})

// 配置Element UI的语言
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
